import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";

const CurrencyTextField = ({ value, onChange, ...props }) => {
  const [inputValue, setInputValue] = useState(
    value ? `$${Number(value).toLocaleString()}` : "",
  );

  useEffect(() => {
    setInputValue(value ? `$${Number(value).toLocaleString()}` : "");
  }, [value]);

  const handleChange = (e) => {
    const raw = e.target.value.replace(/[^0-9.]/g, "");
    const num = parseFloat(raw);
    if (!isNaN(num) && num >= 0) {
      setInputValue(`$${num.toLocaleString()}`);
      onChange(raw);
    } else {
      setInputValue("");
      onChange("");
    }
  };

  return <TextField {...props} value={inputValue} onChange={handleChange} />;
};

export default CurrencyTextField;
